import { useState, useEffect } from 'react';
import { view, bowser } from '@yola/ws-sdk';
import { useSelector } from 'react-redux';
import topbar from 'src/js/modules/topbar';
import usePrevious from '../../../../utils/custom-hooks/use-previous';
import { PANE_DEFAULT_INDENT } from '../../../../control-pane/constants/sizes';
import { EDITOR_TOPBAR_DEFAULT_HEIGHT } from '../../../../topbar/constants';

const useControlTopPosition = (elementId) => {
  const liveDocument = view.accessors.getLiveDocument();
  const scrollPosition = view.accessors.getScrollPosition();
  const element = view.accessors.getLiveElement(elementId);
  const elementOffset = view.accessors.getElementOffset(element);
  const windowHeight = liveDocument?.defaultView?.innerHeight || 0;
  const isAppleWithTouch = bowser.ios || bowser.iPadOS;
  const topbarHeight = useSelector(topbar.selectors.getHeight);

  const [topPosition, setTopPosition] = useState(0);
  const [currentScrollPosition, setCurrentScrollPosition] = useState(scrollPosition);
  const prevScrollPosition = usePrevious(currentScrollPosition);

  useEffect(() => {
    const handleScrollPosition = () => setCurrentScrollPosition(view.accessors.getScrollPosition());

    if (isAppleWithTouch) {
      liveDocument?.addEventListener('touchmove', handleScrollPosition, true);
    } else {
      liveDocument?.addEventListener('scroll', handleScrollPosition);
    }

    return () => {
      if (isAppleWithTouch) {
        liveDocument?.removeEventListener('touchmove', handleScrollPosition, true);
      } else {
        liveDocument?.removeEventListener('scroll', handleScrollPosition);
      }
    };
  }, [liveDocument, isAppleWithTouch]);

  useEffect(() => {
    if (currentScrollPosition + topbarHeight + 2 * PANE_DEFAULT_INDENT < elementOffset) {
      setTopPosition(
        elementOffset -
          currentScrollPosition -
          2 * PANE_DEFAULT_INDENT +
          (prevScrollPosition - currentScrollPosition) +
          (topbarHeight - EDITOR_TOPBAR_DEFAULT_HEIGHT)
      );
    } else {
      setTopPosition(topbarHeight + PANE_DEFAULT_INDENT);
    }
  }, [currentScrollPosition, prevScrollPosition, elementOffset, windowHeight, topbarHeight]);

  return { topPosition };
};

export default useControlTopPosition;
